// Web loading UI utilities
import { showToast } from '../components/Toast';
import { showLoading, hideLoading } from '../components/Loading';

export const showWebLoading = (message?: string) => {
  showLoading(message || '');
};

export const hideWebLoading = () => {
  hideLoading();
};

export const showWebToast = (message: string) => {
  showToast(message);
};
